<!-- Workaround for load gloria food widget action not firing on iOS sometimes -->
<span
  [attr.data-glf-cuid]="gloriaFoodCuid"
  [attr.data-glf-ruid]="gloriaFoodRuid"
  data-glf-reservation="true"
>
  <a class="btn btn-outline" [class.primary]="isPrimaryColor"> Book table </a>
</span>
